/**
 * マニフェスト管理
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/bulk_regist_manifests`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
  }
}

const bulk_regist_manifest = {

  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
    selectedMembers: (state) => {
      if (state.condition.type_of_manifest === "first_manifest") {
        return state.selectedItemsFirst
      } else {
        return state.selectedItemsSecond
      }
    }
  },
  actions: {
    /**
     * マニフェストの一括本登録
     * @param commit
     * @param ids
     * @param params
     * @return {Promise<unknown>}
     */
     create({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          // commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },

  },
  mutations: {
  },

}

export default bulk_regist_manifest
